<span class="internal-badge" title="Internal use only: no embed code">Internal</span>

<style>
	.internal-badge {
		font-size: 0.65rem;
		font-weight: 600;
		text-transform: uppercase;
		letter-spacing: 0.05em;
		background: #e0e0e0;
		color: #555;
		padding: 1px 5px;
		border-radius: 3px;
		margin-left: 6px;
		vertical-align: middle;
		white-space: nowrap;
	}
</style>
